import utils from "../utils";

export default {
  data() {
    return {
      emotionVisible: false,
      message: ""
    };
  },
  computed: {
    ...mapState({
      isSend: state => state.chat.isSend,
      messages: state => state.chat.messages,
      currentConetnt: state => state.currentConetnt,
      messageImgs: state => state.chat.messageImgs,
      channels: state => state.channels,
      customerInfo: state => state.customerInfo || {},
      currCustomer: state => state.currCustomer || {},
      socketStatus: state => state.socketStatus,
      channelId: state => state.channelId,
      msgType: state => state.msgType,
      showUploadList: state => state.showUploadList
    }),
    isSafari() {
      return (
        /Safari/.test(navigator.userAgent) &&
        !/Chrome/.test(navigator.userAgent)
      );
    }
  },
  mounted() {
    let that = this;
    if (utils.isMobile()) {
      document.addEventListener("click", function(e) {
        if (e.target.className != "icon-emoji") {
          that.emotionVisible = false;
        }
      });
    }
  },
  methods: {
    send(e) {
      console.log(e, "发送消息");
      console.log(this.messageImgs);
      if (utils.isMobile()) {
        console.log("utils.isMobile");
        return;
      }
      if (e.shiftKey && e.code === "Enter") {
        console.log("e.shiftKey && e.code === 'Enter'");
        // 换行
      } else {
        console.log("!e.shiftKey && e.code === 'Enter'");
        this.sendMobile();
        e.preventDefault();
      }
      this.$store.commit("setState", {
        isSend: true
      });
    },
    sendMobile() {
      // 发送消息
      if (this.isMsgUpload) {
        return false;
      }
      this.$store.commit("setState", {
        more: false,
        isshowsend: false
      });
      const socketStatus = this.socketStatus !== 1 ? true : false;
      let channelId = this.channelId
        ? this.channelId
        : this.currCustomer.channelId;
      if (this.messageImgs.length > 0 && !this.isMsgUpload) {
        //如果是图片信息
        this.messageImgs.forEach(image => {
          console.log(image, "图片信息");
          this.$store.dispatch(
            "chat/sendMessage",
            {
              type: constant.MESSAGE_TYPE.MT_IMAGE,
              filePath: image.path,
              localPath: image.localPath,
              channelId,
              name: image.name,
              width: image.width,
              height: image.height,
              socketStatus: socketStatus
            },
            { root: true }
          );
        });
        console.log("清空图片");
        //清空图片预览层
        const dom = document.getElementsByClassName("el-upload-list")[0];
        dom.innerHTML = "";
        //清空store中的图片数据
        this.$store.commit("chat/setState", {
          messageImgs: []
        });
      }
      //文本类信息
      console.log(`文本类信息 ${this.message}`);
      const content = this.message;
      const matchStr = content.match(/[^\s]/g);
      console.log(matchStr);
      const strLength = matchStr ? matchStr.length : 0;
      console.log(strLength);
      if (strLength && !this.isMsgUpload) {
        this.$store.dispatch(
          "chat/sendMessage",
          {
            content: this.message,
            channelId,
            socketStatus: socketStatus
          },
          { root: true }
        );
        this.message = "";
      }
      this.emotionVisible = false;
      let that = this;
      setTimeout(() => {
        that.$store.commit("setState", {
          isSendFlag: true
        });
      }, 100);
      that.$store.commit("setState", {
        isSend: true
      });
    },

    showEmotion() {
      this.emotionVisible = !this.emotionVisible;
    },
    selectEmotion(emoji) {
      const txtArea = this.$refs["message-textarea"];
      const start = txtArea.selectionStart;
      const end = txtArea.selectionEnd;
      txtArea.addEventListener("click", () => {
        this.emotionVisible = false;
      });
      if (start === undefined || end === undefined) return;
      let text = emoji.native;
      const result =
        txtArea.value.substring(0, start) + text + txtArea.value.substring(end);
      txtArea.value = result;

      txtArea.selectionStart = start + text.length;
      txtArea.selectionEnd = start + text.length;

      if (this.isSafari) {
        this.message = result;
      } else {
        this.message = result + " ";
      }

      txtArea.removeEventListener("click", () => {
        this.emotionVisible = false;
      });
      console.log(txtArea.value.length, "changdu", this.more);
      this.$store.commit("setState", {
        isshowsend: true
      });
      console.log(txtArea.value.length, "changdu", this.more);
      utils.isMobile() ? txtArea.blur() : txtArea.focus();
      // console.log(emoji);
    },
    openFileChooser() {
      this.emotionVisible = false;
    },
    showTextareaRightMenu(e) {
      setTimeout(() => {
        e.target.focus();
      }, 300);
    },
    handleFocus() {
      this.emotionVisible = false;
      const txtArea = this.$refs["message-textarea"];
      this.activeElementScrollIntoView(txtArea, 400);
      // setTimeout(function() {
      //   txtArea.scrollIntoView();
      // }, 400);
    },
    activeElementScrollIntoView(activeElement, delay) {
      var editable = activeElement.getAttribute("contenteditable");

      // 输入框、textarea或富文本获取焦点后没有将该元素滚动到可视区
      if (
        activeElement.tagName == "INPUT" ||
        activeElement.tagName == "TEXTAREA" ||
        editable === "" ||
        editable
      ) {
        setTimeout(function() {
          activeElement.scrollIntoView();
          // window.scrollTo(0, Math.max(document.body.clientHeight, document.documentElement.clientHeight) + 2000);
        }, delay);
      }
    }
  },
  watch: {
    currentConetnt(newVal) {
      this.message = newVal;
    },
    // customerInfo() {
    //   console.log("customerInfo change clear message");
    //   this.message = "";
    //   const dom = document.getElementsByClassName("el-upload-list")[0];
    //   if (!dom) {
    //     return;
    //   }
    //   dom.innerHTML = "";
    //   this.$store.commit("chat/setState", {
    //     messageImgs: []
    //   });
    // },
    message(newVal) {
      const txtArea = this.$refs["message-textarea"];
      txtArea.scrollTop = txtArea.scrollHeight + 100;
      if (!newVal) {
        this.$store.commit("setState", {
          currentConetnt: ""
        });
      }
    }
  }
};
